import axios from "axios";
import userManager from "../services/UserManager";

//var headersNames = {
//    contentType: "Content-Type"
//}

const contentTypes = {
    applicationJson: "application/json"
}

const jsonRequestConfig = {
    headers: {
        "Content-Type": contentTypes.applicationJson
    }
};

class MapService {
    constructor() {
        this.mapApiUrl = process.env.REACT_APP_MAPPER_API_URL;
    }

    async retrieve(mapId) {
        if (!mapId) mapId = "welcome";
        const retrieveMapUrl = `${this.mapApiUrl}api/maps/${mapId}`;
        try {
            const response = await axios.get(retrieveMapUrl, jsonRequestConfig);
            response.data.geoJson = JSON.parse(response.data.geoJson);
            response.data.mapId = response.data.id;
            return response.data;
        } catch (e) {
            console.error("Problem retrieving map", e);
            throw e;
        }
    }

    async create() {

        const self = this;
        const user = await userManager.getUser();
        const createMapUrl = `${self.mapApiUrl}api/maps/create`;
        const response = await axios.get(createMapUrl, {
                headers: {
                    "Content-Type": contentTypes.applicationJson,
                    "Authorization": `Bearer ${user.access_token}`
                }
        });
        response.data.mapId = Number(response.data.id);
        return response.data;
    }

    async persist(mapId, geoJson) {

        const user = await userManager.getUser();
        if (!user)
            throw new Error("No authenticated user. Cannot persist map without an authenticated user.");

        const map = {
            id: mapId,
            geoJson: JSON.stringify(geoJson),
            userId: user.profile.sub
        };

        const persistMapUrl = `${this.mapApiUrl}api/maps/${map.id}/update`;

        return axios.post(persistMapUrl, map, {
            headers: {
                "Content-Type": contentTypes.applicationJson,
                "Authorization": `Bearer ${user.access_token}`
            }
        });
    }
}

export default new MapService();